var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSearchCopy3 = function SvgSearchCopy3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#C1C1C1",
    transform: "translate(3.333 3.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5.569,
    x: 10.323,
    y: 7.371,
    rx: 0.5,
    transform: "rotate(-45 10.49 10.156)"
  }))));
};
export default SvgSearchCopy3;